import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function downloadPDF(data,type) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
  return axios.post(
    `${process.env.VUE_APP_API_BASE_URL}/pdf/download-${type}`,
    data,
    options
  ).then(res => {
    return res;
  });
}

export default {
  downloadPDF,
};
